module.exports = __webpack_public_path__ + "static/media/ellipsis-v-solid.c8c287db.svg";